<div class="cmp-input-search">
  <div class="form-group autocomplete-wrapper mb-2 mb-lg-4">
    <div class="input-group">
      <label for="autocomplete-autocomplete-three" class="visually-hidden"
        >Cerca nel sito</label
      >
      <input
        type="search"
        class="autocomplete form-control"
        placeholder="Cerca"
        id="autocomplete-autocomplete-three"
        name="autocomplete-three"
        [(ngModel)]="searchTerm"
        data-bs-autocomplete="[]"
        (keydown)="onEnterPressed($event)"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary"
          type="button"
          id="button"
          (click)="search(searchTerm)"
        >
          Invio
        </button>
      </div>
      <span class="autocomplete-icon" aria-hidden="true">
        <svg class="icon icon-sm icon-primary" aria-label="Cerca nel sito">
          <use href="bootstrap-italia/dist/svg/sprites.svg#it-search"></use>
        </svg>
      </span>
    </div>
  </div>
</div>
